import { apiConfig } from '@/services/api-config';

export default async function (resp: any) {
  return apiConfig
    .post('api/Penalty/update_penalty', resp)
    .then((response) => response.data)
    .catch(() => []);
}
